import * as React from "react";
import {useTranslation} from "react-i18next";
import {usePaymentContext} from "./Payment";
import styles from "./CreditCardContainer.module.scss";

const CreditCardContainer: React.FC = () => {
  const {creditCardImageRef, isPaymentLoading} = usePaymentContext();
  const {t} = useTranslation();

  return (
    <div className={styles.wrapper}>
      {isPaymentLoading && (
        <div className={styles.spinnerContainer}>
          <div className={`swiper-lazy-preloader ${styles.swiperLazyPreloader}`}>{/* loading spinner container */}</div>
        </div>
      )}
      <div className={styles.cardinfoCardNumber}>
        <label htmlFor="card-number" className={styles.ccLabel}>
          {t("checkout.cardNumber")}:
        </label>
        <div id="card-number" className={styles.cardNumber} />
        <div id="card-image" className={styles.cardImage} ref={creditCardImageRef} />
      </div>
      <label htmlFor="cvv">{t("checkout.cvv")}:</label>
      <div id="cvv" className={styles.cvv} />
      <label htmlFor="expiration-date">{t("general.validUntil")}:</label>
      <div id="expiration-date" className={styles.expirationDate} />
      <div id="checkout-message" className={styles.checkoutMessage} />
    </div>
  );
};

export default CreditCardContainer;
